import { isNil } from 'lodash'
import { useSnackbar, VariantType } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { UPSERT_WORKSPACE_KEY_VALUES } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseUpsertWorkspaceKeyValues } from './types'

export const useUpsertWorkspaceKeyValues = (): UseUpsertWorkspaceKeyValues => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection.keyValues.list.actions',
  })
  const { enqueueSnackbar } = useSnackbar()

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPSERT_WORKSPACE_KEY_VALUES,
    queriesToInvalidate: ['workspaceKeyValues'],
  })

  const upsert: UseUpsertWorkspaceKeyValues['upsert'] = async ({ action, id, name }) => {
    const result = await mutateAsync({ input: { workspaceKeyValueIds: [id] } })

    if (result === undefined) {
      return
    }

    const responseErrorsLength: number | undefined = result.errors?.length
    const mutationErrorsLength: number | undefined =
      result.data.upsertWorkspaceKeyValues?.errors?.length

    const variant: VariantType =
      isNil(responseErrorsLength) && isNil(mutationErrorsLength) ? 'success' : 'error'

    enqueueSnackbar(t(`${action}.${variant}`, { name }), { variant })
  }

  return { upsert }
}
